import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { createStorefrontApiClient } from "@shopify/storefront-api-client";
import { BrowserRouter } from "react-router-dom";

const client = createStorefrontApiClient({
	storeDomain: "zephyo.myshopify.com",
	publicAccessToken: "e5fbba05f987f9dda52ccea8596b38ae",
	apiVersion: "2025-01",
});

ReactDOM.hydrate(
	<BrowserRouter>
		<App client={client} />
	</BrowserRouter>,
	document.getElementById("root")
);
